export default __webpack_public_path__ + "static/media/transactions-payments.ff816abb.webp";